import React, { useState } from "react";

const DropdownSection = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-gray-300">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex justify-between items-center py-4 text-left"
      >
        <span className="text-xl font-semibold text-gray-800">{title}</span>
        <span className="text-gray-600">{isOpen ? "−" : "+"}</span>
      </button>
      {isOpen && <div className="pb-4 text-gray-600">{children}</div>}
    </div>
  );
};

export default function About() {
  return (
    <div className="max-w-7xl mx-auto px-6 py-12 space-y-6">
      <h1 className="text-3xl font-bold text-gray-800 mb-6">About Us</h1>

      {/* Our Story */}
      <DropdownSection title="Our Story">
        <p className="mb-4">
          MAC LABS LIMITED began its journey in the pharmaceutical sector as AVIS LABS in 2009
          and has evolved into a trusted, globally recognized manufacturer. With state-of-the-art
          facilities in Bidar, Karnataka, and Bollaram, Telangana, we efficiently serve both domestic
          and international markets.
        </p>
        <p>
          We specialize in manufacturing APIs, drug intermediates, pharmaceutical formulations, UV filters,
          and specialty chemicals. Guided by our Memorandum of Articles of Association, our mission
          is to deliver world-class products while upholding the highest standards of quality, ethics, and innovation.
        </p>
      </DropdownSection>

      {/* Core Strengths */}
      <DropdownSection title="Core Strengths">
        <ul className="list-disc list-inside space-y-2">
          <li>Proven expertise in API, drug intermediates, and specialty chemicals manufacturing</li>
          <li>Compliance with WHO and GMP quality standards</li>
          <li>Dual strategic facilities for enhanced production and distribution capabilities</li>
          <li>Ethical, transparent, and customer-focused business practices</li>
          <li>Advanced infrastructure with scalability for future growth</li>
        </ul>
      </DropdownSection>

      {/* Philosophy */}
      <DropdownSection title="Our Philosophy">
        <div className="mb-4">
          <h3 className="text-lg font-semibold mb-1">Vision</h3>
          <p>
            To be a globally admired manufacturer of APIs, Intermediates, UV Filters, and Specialty Chemicals — 
            setting benchmarks in safety, quality, and customer satisfaction while driving innovation and sustainable growth.
          </p>
        </div>
        <div className="mb-4">
          <h3 className="text-lg font-semibold mb-1">Mission</h3>
          <ul className="list-disc list-inside space-y-2">
            <li>Ensure safety first in every process, protecting people, customers, and environment.</li>
            <li>Deliver superior-quality APIs, fine chemicals, and intermediates meeting global standards.</li>
            <li>Continuously improve through innovation and advanced technology.</li>
            <li>Build enduring partnerships based on trust and transparency.</li>
          </ul>
        </div>
        <div>
          <h3 className="text-lg font-semibold mb-1">Core Values</h3>
          <ul className="list-disc list-inside space-y-2">
            <li>Safety as Our Foundation</li>
            <li>Quality Without Compromise</li>
            <li>Customer Delight</li>
            <li>Ethical Integrity</li>
            <li>One Team, One Vision</li>
          </ul>
        </div>
      </DropdownSection>

      {/* Leadership */}
      <DropdownSection title="Our Leadership">
        <div className="grid md:grid-cols-2 gap-6">
          <div className="p-4 bg-gray-50 rounded shadow">
            <h3 className="text-lg font-semibold">SIVA SANKARA REDDY – Managing Director</h3>
            <p className="italic">“Discipline in action, vision in progress.”</p>
            <p>
              An Ex-Army professional, he brings discipline, dedication, and a relentless work ethic to MAC LABS.
              Under his leadership, the company has expanded globally and earned a reputation for reliability and trust.
            </p>
          </div>
          <div className="p-4 bg-gray-50 rounded shadow">
            <h3 className="text-lg font-semibold">DIVYA SHANKAR – Director</h3>
            <p className="italic">"Passion with purpose, progress with precision."</p>
            <p>
              A graduate in M. Pharma, Divya Shankar’s dedication and strategic vision have strengthened MAC LABS’
              reputation for quality, innovation, and reliability.
            </p>
          </div>
        </div>
      </DropdownSection>

      {/* Facilities */}
      <DropdownSection title="Our Facilities">
        <div className="space-y-4">
          <div className="p-4 bg-gray-50 rounded shadow">
            <h3 className="font-semibold">UNIT I – Bidar, Karnataka</h3>
            <p>
              Equipped with state-of-the-art production lines for APIs, intermediates, UV filters, and specialty chemicals.
              Robust safety systems, energy-efficient operations, ISO 9001:2015 and GMP certified.
            </p>
            <p>Reactor Capacity: 30 | Total Volume: 100 KL</p>
            <p>Location: Plot No. 282, 283 & 284, KIADB, Kolhar Industrial Area, Bidar, Karnataka, India</p>
          </div>
          <div className="p-4 bg-gray-50 rounded shadow">
            <h3 className="font-semibold">UNIT II – Bollaram, Telangana</h3>
            <p>
              Specialized for high-quality APIs and intermediates with excellent connectivity to highways, ports, and airports.
            </p>
            <p>Location: Plot No. 103D, Sri Venkateswara Industrial Estate, IDA Bollaram, Telangana, India</p>
          </div>
        </div>
      </DropdownSection>
    </div>
  );
}
